export function tryCast<T>(value: any, typename: string): T | undefined {
    return (typeof value === 'object' && value?.__typename === typename) ? value as T : undefined;
}
